module.exports = __webpack_public_path__ + "static/media/8.effecb36.jpg";